module.exports = __webpack_public_path__ + "static/media/title_bg_4.990bfa66.png";